import FadeAnimation from "@components/animations/FadeAnimation";
import GenericInputGroup from "@components/input/inputGroup/GenericInputGroup";
import ModuleContext from "../ModuleContext";
import { ConditionalSection } from "@typedefs/modulesInterfaces";
import { handleDisableSww } from "./moduleUtils";
import { useContext } from "react";

const ConditionalSectionRenderer = ({
  conditionalSection,
  showConditionalSection,
  isReadOnly,
  index
}: {
  conditionalSection: ConditionalSection,
  showConditionalSection: boolean,
  isReadOnly: boolean,
  index?: number
}) => {
  const { belongsToLuc } = useContext(ModuleContext)

  if (!conditionalSection) return null;
  return (
    <>
      {conditionalSection.conditionInput && (
        <div className="py-2" key={conditionalSection.conditionInput.label}>
          <GenericInputGroup
            inputGroup={{
              ...conditionalSection.conditionInput,
              disabled: isReadOnly,
              index
            }}
          />
        </div>
      )}

      <FadeAnimation isShown={showConditionalSection}>
        {conditionalSection.inputGroups.map((input, i) => {
          const curatedInput = handleDisableSww({ input, belongsToLuc, isReadOnly, index });
          return (
            <div className="py-2" key={`${input.label}-${index !== undefined ? index + '-' : ''}${i}`}>
              <GenericInputGroup
                inputGroup={{
                  ...curatedInput,
                  disabled: isReadOnly,
                  index
                }}
              />
            </div>
          )
        })}

      </FadeAnimation>
    </>
  );
};

export default ConditionalSectionRenderer